module.exports = __webpack_public_path__ + "static/vegetarian-friendly-dfdd285817ecf2f4870473cd8fae9e76.png";